import { render, staticRenderFns } from "./page1.vue?vue&type=template&id=23f762e0&scoped=true&"
import script from "./page1.vue?vue&type=script&lang=ts&"
export * from "./page1.vue?vue&type=script&lang=ts&"
import style0 from "./page1.vue?vue&type=style&index=0&id=23f762e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f762e0",
  null
  
)

export default component.exports